import {CSSProperties} from "react";

export const formDialogFlexStyle: CSSProperties = {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column'
};